"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopper = require("react-popper");

var _styledComponents = require("styled-components");

var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));

var _constants = require("../constants");

var _Stack = _interopRequireDefault(require("../Stack"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _util = require("../../theme/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var animScaleIn = (0, _styledComponents.keyframes)(["0%{opacity:0;transform:scale(0);}100%{opacity:1;transform:scale(1);}"]);
var animScaleOut = (0, _styledComponents.keyframes)(["0%{opacity:1;transform:scale(1);}100%{opacity:0;transform:scale(0);}"]);

var getCss = function getCss(_ref) {
  var animationDuration = _ref.animationDuration;
  return (0, _styledComponents.css)(["&[data-state=entering],&[data-state=entered]{animation:", " ", "ms ", " both;}&[data-state=exiting]{animation:", " ", "ms ", " both;}"], animScaleIn, animationDuration, _util.transition, animScaleOut, animationDuration, _util.transition);
};

var getTransformOrigin = function getTransformOrigin(_ref2) {
  var position = _ref2.position;

  switch (position) {
    case _constants.Position.BOTTOM:
      return 'top center';

    case _constants.Position.BOTTOM_LEFT:
      return 'top left';

    case _constants.Position.BOTTOM_RIGHT:
      return 'top right';

    case _constants.Position.TOP:
      return 'bottom center';

    case _constants.Position.TOP_LEFT:
      return 'bottom left';

    case _constants.Position.TOP_RIGHT:
      return 'bottom right';

    case _constants.Position.RIGHT:
      return 'center left';

    case _constants.Position.LEFT:
      return 'center RIGHT';
  }

  ;
};

var Positioner = function Positioner(_ref3) {
  var target = _ref3.target,
      position = _ref3.position,
      children = _ref3.children,
      isShown = _ref3.isShown,
      innerRef = _ref3.innerRef,
      animationDuration = _ref3.animationDuration,
      offset = _ref3.offset;

  var _React$useState = _react["default"].useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      targetEl = _React$useState2[0],
      setTargetEl = _React$useState2[1];

  var targetRef = _react["default"].useCallback(function (node) {
    return setTargetEl(node);
  }, []);

  if (typeof target !== 'function' && target !== targetEl) {
    setTargetEl(target);
  }

  var getRef = function getRef(node) {
    if (innerRef) innerRef.current = node;
  };

  return _react["default"].createElement(_Stack["default"], {
    value: _Stack["default"].constants.OVERLAY
  }, function (zIndex) {
    return _react["default"].createElement(_react["default"].Fragment, null, typeof target === 'function' && target({
      ref: targetRef
    }), _react["default"].createElement(_Transition["default"], {
      appear: true,
      unmountOnExit: true,
      "in": isShown,
      timeout: animationDuration
    }, function (state) {
      return _react["default"].createElement(_reactPopper.Popper, {
        innerRef: getRef,
        placement: position,
        referenceElement: targetEl,
        positionFixed: true,
        modifiers: {
          offset: {
            offset: "0, ".concat(offset)
          },
          computeStyle: {
            gpuAcceleration: false
          }
        }
      }, function (_ref4) {
        var ref = _ref4.ref,
            style = _ref4.style;
        return _react["default"].createElement(_Portal["default"], null, children({
          ref: ref,
          style: _objectSpread({}, style, {
            transformOrigin: getTransformOrigin({
              position: position
            })
          }),
          state: state,
          zIndex: zIndex,
          css: getCss({
            animationDuration: animationDuration
          })
        }));
      });
    }));
  });
};

Positioner.propTypes = {
  isShown: _propTypes["default"].bool.isRequired,
  target: _propTypes["default"].any,
  //oneOf function,node
  animationDuration: _propTypes["default"].number,
  position: _propTypes["default"].oneOf([_constants.Position.TOP, _constants.Position.TOP_LEFT, _constants.Position.TOP_RIGHT, _constants.Position.LEFT, _constants.Position.RIGHT, _constants.Position.BOTTOM, _constants.Position.BOTTOM_LEFT, _constants.Position.BOTTOM_RIGHT])
};
Positioner.defaultProps = {
  isShown: true,
  position: _constants.Position.BOTTOM,
  animationDuration: 150,
  offset: 0
};
var _default = Positioner;
exports["default"] = _default;